import { render, staticRenderFns } from "./ModeratorMagnet.vue?vue&type=template&id=8a26d12e"
import script from "./ModeratorMagnet.vue?vue&type=script&lang=js"
export * from "./ModeratorMagnet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports